import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.1836 9.95312L17.1211 11.6406C17.7539 11.8867 18.1055 12.5547 17.9648 13.2227L17.1211 17.1602C16.9805 17.793 16.3828 18.2852 15.75 18.2852C15.5039 18.2852 15.293 18.25 15.082 18.25C14.7305 18.25 14.3789 18.2148 14.0625 18.1797C6.15234 17.3359 0 10.6562 0 2.5C0 1.86719 0.457031 1.26953 1.08984 1.12891L5.02734 0.285156C5.69531 0.144531 6.36328 0.496094 6.60938 1.12891L8.29688 5.06641C8.54297 5.62891 8.40234 6.29688 7.91016 6.68359L6.46875 7.87891C7.41797 9.49609 8.75391 10.832 10.3711 11.7812L11.5664 10.3398C11.9531 9.84766 12.6211 9.70703 13.1836 9.95312ZM15.5039 16.5625L16.2422 13.082L12.7266 11.5703L11.707 12.8359C11.1797 13.4688 10.2656 13.6445 9.52734 13.2227C7.66406 12.1328 6.11719 10.5859 5.02734 8.72266C4.60547 7.98438 4.78125 7.07031 5.41406 6.54297L6.67969 5.52344L5.16797 2.00781L1.6875 2.74609C1.79297 10.3398 7.91016 16.457 15.5039 16.5625Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
